import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  padding: ${({ theme }) => theme.space["space-6"]} 0;

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }
`;

export const Row = styled.div<{
  isSingleSelection?: boolean;
}>`
  display: flex;

  :not(:first-child, :last-child) {
    padding: ${({ theme }) => theme.space["space-5"]} 0;

    @media screen and ${breakpoints.tablet.max.sm} {
      padding: ${({ theme }) =>
        `0 ${theme.space["space-4"]} ${theme.space["space-4"]} ${theme.space["space-4"]}`};
    }
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: ${({ theme }) =>
      `0 ${theme.space["space-4"]} ${theme.space["space-4"]} ${theme.space["space-4"]}`};
    border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};
    justify-content: space-between;
    ${({ isSingleSelection }) =>
      !isSingleSelection &&
      css`
        flex-direction: column;
      `}
  }
`;

export const RunnerInfo = styled.div`
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-left: ${({ theme }) => theme.space["space-3"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    justify-content: center;
    row-gap: ${({ theme }) => theme.space["space-1"]};
    padding-top: ${({ theme }) => theme.space["space-4"]};
  }
`;

export const ContainerPickNumber = styled.div<{ isScratched: boolean }>`
  padding-top: ${({ theme }) => theme.space["space-1"]};
  ${({ isScratched }) =>
    isScratched &&
    css`
      opacity: 0.4;
    `}
`;

export const BetButtonsContainer = styled.div<{
  isSingleSelection?: boolean;
}>`
  display: inline-block;
  padding-left: ${({ theme }) => theme.space["space-4"]};
  margin: auto 0;
  flex-shrink: 0;

  @media screen and ${breakpoints.tablet.max.sm} {
    ${({ isSingleSelection }) =>
      !isSingleSelection &&
      css`
        padding: ${({ theme }) => theme.space["space-4"]} 0 0;
      `}
    & > div > div:first-child {
      flex-grow: 1;
    }

    & > div > div:last-child:not(:only-child) {
      margin-left: ${({ theme }) => theme.space["space-1"]};
    }
  }
`;

export const ScrLabelContainer = styled.div`
  padding-left: ${({ theme }) => theme.space["space-4"]};
  margin: auto 0;
`;

export const ContainerRunnerInfo = styled.div`
  display: flex;
  width: 100%;
  flex-grow: 1;
`;
